import { render, staticRenderFns } from "./ProductNewReparationPage.vue?vue&type=template&id=3affe2ff&"
import script from "./ProductNewReparationPage.vue?vue&type=script&lang=js&"
export * from "./ProductNewReparationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports